import { put, take } from 'redux-saga/effects';

import { EXIT_SNIPPET } from './actions';
import { RESET_READER } from 'reducers/compModels';
import { notifications, SET_ISLOADING } from 'PipeRouter';


function* exitSnippet() {
  while (true) {
    yield take(EXIT_SNIPPET);

    yield put(notifications(SET_ISLOADING, true));
    yield put({ type: RESET_READER });

    window.vsViewer.Snippet.exit((e, data) => {
    });
  }
}


export default exitSnippet;
